import React, { useMemo } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Tag } from 'primereact/tag';
import { Message } from 'primereact/message';
import { useLanguage } from '../../../../../contexts/LanguageContext';
import { DATA_SCOPE_KEYS } from '../../constants';

// Kaydedilmiş rollere göre kullanıcının etkin yetkileri (rollerin birleşimi, en geniş kapsam)
const EffectivePermissionsPanel = ({ effective, loading }) => {
    const { th } = useLanguage();

    const rows = useMemo(
        () =>
            (effective?.permissions || []).map((p) => {
                const parts = p.code.split('.');
                return { ...p, module: parts[0], action: parts[parts.length - 1], resource: parts.slice(0, -1).join('.') };
            }),
        [effective]
    );

    if (effective?.isAdmin) return <Message severity="info" className="w-full justify-content-start" text={th('authorizationV2.user.adminHasAll')} />;

    const effectiveRoles = Object.entries(effective?.effectiveRoles || {});

    return (
        <>
            {effectiveRoles.length > 0 && (
                <div className="flex flex-wrap gap-2 mb-3">
                    {effectiveRoles.map(([module, role]) => (
                        <Tag key={module} severity="info" value={`${th(`authorizationV2.modules.${module}`, { fallback: module })}: ${role}`} />
                    ))}
                </div>
            )}
            <DataTable value={rows} loading={loading} size="small" paginator rows={10} sortField="code" sortOrder={1} emptyMessage={th('authorizationV2.user.noPermissions')}>
                <Column field="module" header={th('authorizationV2.matrix.module')} sortable body={(r) => th(`authorizationV2.modules.${r.module}`, { fallback: r.module })} />
                <Column field="resource" header={th('authorizationV2.matrix.screen')} sortable />
                <Column field="action" header={th('authorizationV2.matrix.action')} sortable body={(r) => th(`authorizationV2.actions.${r.action}`, { fallback: r.action })} />
                <Column field="scope" header={th('authorizationV2.matrix.scope')} sortable body={(r) => th(`authorizationV2.scopes.${DATA_SCOPE_KEYS[r.scope]}`)} />
                <Column header={th('authorizationV2.user.sourceRoles')} body={(r) => (r.sourceRoles || []).join(', ')} />
            </DataTable>
        </>
    );
};

export default EffectivePermissionsPanel;
